// import React from "react";
// import "./FloatingOrderButton.css";

// const FloatingOrderButton = () => {
//   return (
//     <a
//       href="https://bakelore.com/order-online"
//       target="_blank"
//       rel="noopener noreferrer"
//       className="love-float-btn"
//       aria-label="Order Now"
//     >
//       ORDER
//       {/* hearts container */}
//       <span className="hearts">
//         <span>❤️</span>
//         <span>💖</span>
//         <span>💕</span>
//         <span>💗</span>
//         <span>💘</span>
//       </span>
//     </a>
//   );
// };

// export default FloatingOrderButton;


import React from "react";
import "./FloatingOrderButton.css";

const FloatingOrderButton = () => {
  const symbols = ["🎂", "🍰", "🥐", "🍕", "🧁", "🍪", "🥯", "🫓", "🍩", "🍫", "🍬", "🍭"];
  
  return (
    <a
      href="#"
      target="_blank"
      rel="noopener noreferrer"
      className="burst-float-btn"
    >
      ORDER<br />Now
      <div className="symbols">
        {symbols.map((sym, i) => (
          <span key={i} className="symbol">{sym}</span>
        ))}
      </div>
    </a>
  );
};

export default FloatingOrderButton;
